import logo from "./logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter, Route, Link, Routes } from "react-router-dom";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Home from "./components/Home";
import header_logo from "./image/logo.png";
import Header from "./components/Header";
import AppAds from "./components/AppAds";

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacyPolicy" element={<Privacy />} />
        <Route path="/termsCondition" element={<Terms />} />
        <Route path="/app-ads.txt" element={<AppAds />} />
      </Routes>
    </div>
  );
}

export default App;
